import React from 'react';

import Image from '../../../../library/image/image';

import styles from './unstuddable-image.scss';

function UnstuddableImage() {
  return (
    <Image
      alt="Unstuddable"
      className={styles['unstuddable-image']}
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_unstuddable-tire.svg"
      width="24"
    />
  );
}

export default UnstuddableImage;
